import type { PresentationIsEmptyProps } from '../../'
export default function isEmpty({ section, quote }: PresentationIsEmptyProps) {
  const hasContent = quote?.terms?.content && quote.terms.content.replace('<p></p>', '').trim()
  return !hasContent
}
